import { formatCountWithItem } from '@/lib/utils';

interface ResultsHeaderProps {
  title: string;
  count?: number;
  loading?: boolean;
  itemName?: string;
  actions?: React.ReactNode;
  gender?: 'm' | 'f';
}

export function ResultsHeader({
  title,
  count,
  loading,
  itemName = 'resultado',
  actions,
  gender = 'f'
}: ResultsHeaderProps) {
  return (
    <div className="flex justify-between items-center mb-6">
      <div>
        <h2 className="text-2xl font-bold text-gray-900">
          {title}
        </h2>
        {!loading && count !== undefined && (
          <p className="text-gray-600 mt-1">
            {formatCountWithItem(count, itemName, 'encontrado', gender)}
          </p>
        )}
      </div>
      {actions && <div>{actions}</div>}
    </div>
  );
}